import React, { useMemo, useState } from "react";

//customHook
import useMinimizar from '../../customHooks/useMinimizar';

import './ActivosList.css'; 

import RRActivo from "../renderRows/RRActivo";
import normalizeText from "../../utils/normalizeText";
import ModalForm from "../modalForm/ModalForm";
import FormConsumo from "../formConsumo/FormConsumo";

const ActivosList = ({activos,nivel3,nivel3Selected,filter, componentePadre}) =>{

    const {activoToEdit,setActivoToEdit, indexToEdit,setIndexToEdit, indexAddConsumo,setIndexAddConsumo, formToShow,setFormToShow, minimizar,minimizarFormConsumo} = useMinimizar();
    
    const activosFiltered = useMemo(()=> (activos && activos.length > 0) ? activos.filter((a) => {
        return filter != '' ? 
        (filter.charAt(0) == '"' && filter.charAt(filter.length - 1) == '"') ?
        (normalizeText(a.codActivo) == normalizeText(filter.replaceAll('"','')) || normalizeText(a.name) == normalizeText(filter.replaceAll('"','')))
        :
        (normalizeText(a.codActivo).includes(normalizeText(filter)) || normalizeText(a.name).includes(normalizeText(filter)))
        : true
    }) : null
    , [activos, filter]);
    
    const activoAddingConsumo = (activosFiltered && indexAddConsumo > -1) ? activosFiltered[indexAddConsumo] : null;

    return <div className={`activosListDiv`} >
        {(activosFiltered) ? activosFiltered.map((activo, i) => <RRActivo key={`${activo.codActivo}-${i}`} activo={activo} setActivoToEdit={setActivoToEdit} indexToEdit={indexToEdit} indexAddConsumo={indexAddConsumo} setIndexAddConsumo={setIndexAddConsumo} index={i} setIndexToEdit={setIndexToEdit} setFormToShow={setFormToShow} componentePadre={componentePadre} activosForLocalStorage={JSON.stringify(activos)}/>) : <div className="activoDiv">
            <h4>No hay activos para mostrar</h4>
        </div>}
        {(indexToEdit != -1) && <ModalForm activoToEdit={activoToEdit} componentePadre={"Activo"} indexToEdit={indexToEdit} setIndexToEdit={setIndexToEdit} formToShow={formToShow} setFormToShow={setFormToShow} minimizar={minimizar}/>}
        {(indexAddConsumo > -1) && <div className="modalFormContainer">
            <FormConsumo req={{}} activoAddingConsumo={activoAddingConsumo} mode={"add"} type={"modal"} cerrar={minimizarFormConsumo}/>
        </div>}

    </div>
}

export default ActivosList;